import Heading from "@vfuk/core-heading";
import { useTranslation } from "react-i18next";
import { Dispatch } from "react";
import { SetStateAction } from "react";
import ValidationCheckIcon from "./ValidationCheckIcon";
import { FloatingLabelInput } from "@ucchub/ui";

interface ChangePasswordFormProps {
  newPassword: string;
  onNewPassword: Dispatch<SetStateAction<string>>;
  confirmNewPassword: string;
  onConfirmNewPassword: Dispatch<SetStateAction<string>>;
  email: string;
  onEmail: Dispatch<SetStateAction<string>>;
  hasLettersNumbersSymbols: boolean;
  hasEnoughCharacters: boolean;
  hasUpperAndLowerCase: boolean;
  resetPasswordCode?: string;
}

const ChangePasswordForm = ({
  newPassword,
  onNewPassword,
  confirmNewPassword,
  onConfirmNewPassword,
  hasLettersNumbersSymbols,
  hasEnoughCharacters,
  hasUpperAndLowerCase,
  resetPasswordCode,
  email,
  onEmail,
}: ChangePasswordFormProps) => {
  const { t } = useTranslation();
  const hasForgotPassword = !!resetPasswordCode;

  return (
    <div>
      <Heading size={3}>
        {hasForgotPassword
          ? t("core:auth:title_reset_password")
          : t("core:auth:title_change_password")}
      </Heading>

      {hasForgotPassword && (
        <FloatingLabelInput
          label={t("core:auth:username")}
          type="email"
          value={email}
          id="email"
          onChange={(e) => {
            onEmail(e.target.value);
          }}
        />
      )}
      <br />
      <FloatingLabelInput
        label={t("core:auth:password")}
        type="password"
        placeholder=""
        value={newPassword}
        id="password"
        onChange={(e) => onNewPassword(e.target.value)}
      />
      <br />
      <FloatingLabelInput
        label={t("core:auth:confirm_password")}
        type="password"
        value={confirmNewPassword}
        id="confirmPassword"
        onChange={(e) => onConfirmNewPassword(e.target.value)}
      />

      <br />

      <ValidationCheckIcon
        text={t("core:auth:validation_characters")}
        isValid={hasEnoughCharacters}
      />
      <ValidationCheckIcon
        text={t("core:auth:validation_symbols")}
        isValid={hasLettersNumbersSymbols}
      />
      <ValidationCheckIcon
        text={t("core:auth:validation_case")}
        isValid={hasUpperAndLowerCase}
      />
    </div>
  );
};

export default ChangePasswordForm;
